import React, { useEffect, useState } from 'react';
import API from '../api';
import toast from 'react-hot-toast';

export default function Rates() {
  const [rates, setRates] = useState([]);
  const [editing, setEditing] = useState(null);

  useEffect(() => { API.get('/rates').then(r => setRates(r.data.data)); }, []);

  const save = async (method, data) => {
    try {
      await API.put('/rates/' + method, data);
      toast.success('Rate updated!');
      setEditing(null);
      API.get('/rates').then(r => setRates(r.data.data));
    } catch (err) {
      toast.error('Error updating rate');
    }
  };

  return (
    <div style={{ padding: 32 }}>
      <h1 style={{ margin: '0 0 24px', fontSize: 24, color: '#1e293b' }}>Shipping Rates</h1>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 24 }}>
        {rates.map(rate => (
          <RateCard key={rate.method} rate={rate} editing={editing === rate.method} onEdit={() => setEditing(rate.method)} onSave={data => save(rate.method, data)} onCancel={() => setEditing(null)} />
        ))}
      </div>
    </div>
  );
}

function RateCard({ rate, editing, onEdit, onSave, onCancel }) {
  const icons = { sea: '🚢', land: '🚛', air: '✈️' };
  const [form, setForm] = useState({ rate_per_kg: rate.rate_per_kg, rate_per_cbm: rate.rate_per_cbm, kg_per_cbm: rate.kg_per_cbm, cbm_threshold: rate.cbm_threshold });
  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  return (
    <div style={{ background: '#fff', borderRadius: 12, padding: 24, boxShadow: '0 1px 4px rgba(0,0,0,0.08)' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
        <h2 style={{ margin: 0, fontSize: 20 }}>{icons[rate.method]} {rate.method.toUpperCase()}</h2>
        {!editing && <button onClick={onEdit} style={{ background: '#f97316', color: '#fff', border: 'none', borderRadius: 8, padding: '6px 16px', cursor: 'pointer', fontWeight: 600 }}>Edit</button>}
      </div>
      {editing ? (
        <>
          {[['Rate per KG ($)', 'rate_per_kg'],['Rate per CBM ($)', 'rate_per_cbm'],['KG per CBM', 'kg_per_cbm'],['CBM Threshold', 'cbm_threshold']].map(([label, key]) => (
            <div key={key} style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 4 }}>{label}</label>
              <input type="number" step="0.01" value={form[key]} onChange={e => set(key, e.target.value)} style={{ width: '100%', padding: '8px 12px', border: '1px solid #d1d5db', borderRadius: 8, fontSize: 14, boxSizing: 'border-box' }} />
            </div>
          ))}
          <div style={{ display: 'flex', gap: 8 }}>
            <button onClick={() => onSave(form)} style={{ flex: 1, padding: 10, background: '#f97316', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>Save</button>
            <button onClick={onCancel} style={{ flex: 1, padding: 10, background: '#f1f5f9', border: 'none', borderRadius: 8, cursor: 'pointer' }}>Cancel</button>
          </div>
        </>
      ) : (
        <>
          {[['Rate per KG', '$' + rate.rate_per_kg],['Rate per CBM', '$' + rate.rate_per_cbm],['KG per CBM', rate.kg_per_cbm + ' kg'],['CBM Threshold', rate.cbm_threshold + ' m³']].map(([label, value]) => (
            <div key={label} style={{ display: 'flex', justifyContent: 'space-between', padding: '8px 0', borderBottom: '1px solid #f1f5f9', fontSize: 14 }}>
              <span style={{ color: '#64748b' }}>{label}</span>
              <span style={{ fontWeight: 600 }}>{value}</span>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
